export const datadogConfig = {
  DD_CLIENT_TOKEN: 'pub490c5077ea6632ac2b0fc5e19bba0f13',
  DD_SITE: 'datadoghq.com',
  DD_SERVICE: 'mikmak-platform',
  DD_FORWARD_ERRORS_TO_LOGS: true,
  DD_SAMPLE_RATE: 100,
};
